import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { useSaveWealthSurvey } from '../../hooks/api/wealth/wealth';
import { toast } from 'react-toastify';

const MultiStepForm: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(0);
const saveSurveyAPI= useSaveWealthSurvey()
  const validationSchema = [
    Yup.object().shape({
      name: Yup.string().required('Required'),
      dob: Yup.date().required('Required'),
      occupation: Yup.string().required('Required'),
      maritalStatus: Yup.string().required('Required'),
      dependents: Yup.number().integer().required('Required'),
      annualIncome: Yup.number().required('Required'),
      netWorth: Yup.number().required('Required'),
      wealthSource: Yup.string().required('Required'),
      investmentExperience: Yup.number().integer().required('Required'),
    }),
    Yup.object().shape({
      investmentGoals: Yup.array().of(Yup.string()),
      timeHorizon: Yup.string().required('Required'),
      investmentType: Yup.string().required('Required'),
      currency: Yup.array().of(Yup.string()),
      liquidityNeeds: Yup.string(),
      liquidAssetPortion: Yup.string().required('Required'),
      legalConsiderations: Yup.string(),
    }),
    Yup.object().shape({
      riskTolerance: Yup.string().required('Required'),
      returnExpectations: Yup.string().required('Required'),
      portfolioDeclineReaction: Yup.string().required('Required'),
    }),
    Yup.object().shape({
      moneyMarket: Yup.number().min(0).max(100).required('Required'),
      bonds: Yup.number().min(0).max(100).required('Required'),
      equities: Yup.number().min(0).max(100).required('Required'),
      alternatives: Yup.number().min(0).max(100).required('Required'),
      assetAvoidance: Yup.string(),
      marketOpportunity: Yup.string(),
      sri: Yup.string(),
    }),
    Yup.object().shape({
      performanceHistory: Yup.boolean(),
      riskLevel: Yup.boolean(),
      managementQuality: Yup.boolean(),
      fees: Yup.boolean(),
      ethicalConsiderations: Yup.boolean(),
      otherFactors: Yup.string(),
    }),
    Yup.object().shape({
      reportFrequency: Yup.string().required('Required'),
      reviewFrequency: Yup.string().required('Required'),
      rebalancing: Yup.string(),
    }),
    Yup.object().shape({
      ethicalAvoidance: Yup.string(),
    }),
    Yup.object().shape({
      feeStructure: Yup.string().required('Required'),
      feeCommunication: Yup.string().required('Required'),
    }),
    Yup.object().shape({
      additionalInfo: Yup.string(),
      specificConcerns: Yup.string(),
    }),
  ];

  const initialValues = {
    name: '', dob: '', occupation: '', maritalStatus: '', dependents: 0,
    annualIncome: 0, netWorth: 0, wealthSource: '', investmentExperience: 0,
    investmentGoals: [], timeHorizon: '', investmentType: '', currency: [],
    liquidityNeeds: '', liquidAssetPortion: '', legalConsiderations: '',
    riskTolerance: '', returnExpectations: '', portfolioDeclineReaction: '',
    moneyMarket: 0, bonds: 0, equities: 0, alternatives: 0, assetAvoidance: '',
    marketOpportunity: '', sri: '',
    performanceHistory: false, riskLevel: false, managementQuality: false,
    fees: false, ethicalConsiderations: false, otherFactors: '',
    reportFrequency: '', reviewFrequency: '', rebalancing: '',
    ethicalAvoidance: '',
    feeStructure: '', feeCommunication: '',
    additionalInfo: '', specificConcerns: '',"clientSignatureDate":new Date().toISOString(), "wealthMgr_SignatureDate":new Date().toISOString(),
  };

  const handleNext = (values: any) => {
    setCurrentStep(currentStep + 1);
  };

  const handlePrev = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleSubmit = (values: any) => {
    // setCurrentStep(currentStep + 1);
    console.log(values); // Replace with your submission logic
  toast.dismiss()
    toast.loading(`Submitting Survey`)
    saveSurveyAPI.mutate(values, {
    onSuccess(surveyResponse){
toast.dismiss()
toast.success(`Survey Submitted Successfully`)

    }, onError(surveyError){
console.log({surveyError})
toast.dismiss()
toast.error(`Error Submitting Survey`)

    }
   })
    // alert("Form Submitted! Check console for data")
  };

  const renderStep = (props: any) => {
    switch (currentStep) {
      case 0: return <PersonalFinancialInfo {...props} />;
      case 1: return <InvestmentObjectives {...props} />;
      case 2: return <RiskToleranceReturn {...props} />;
      case 3: return <AssetAllocation {...props} />;
      case 4: return <InvestmentCriteria {...props} />;
      case 5: return <PortfolioMonitoring {...props} />;
      case 6: return <EthicalConsiderations {...props} />;
      case 8: return <FeesTransparency {...props} />;
      case 7: return <AdditionalInformation {...props} />;
      default: return null;
    }
  };


  return (
//     <div className="bg-[#5d2684] h-screen flex flex-col justify-center items-center p-4">
//  <h2 className='text-center text-white text-3xl font-bold mb-2'>FCMB ASSET MANAGEMENT WEALTH ONBOARDING</h2>
//     <div className="bg-white w-full max-w-screen-lg p-4 rounded-md h-[600px] overflow-x-scroll" style={ {boxShadow:        "3px 3px 7px rgba(93,38,132, 0.1), -3px -3px 7px rgba(93,38,132, 0.1)",  }}>
  
  <div className="gradient-bg  h-screen flex flex-col justify-center items-center p-4">
      <div className="max-w-screen-lg w-full prose"> {/* Container for centering and width control */}
        <h2 className="text-center text-4xl font-bold mb-6 tracking-wide text-white ">
          FCMB ASSET MANAGEMENT <span className="gradient-texts">WEALTH SURVEY </span>
        </h2>
        <div
          className="bg-white rounded-lg shadow-2xl overflow-y-auto max-h-[70vh] p-6" // Improved styling
          style={{
            boxShadow: "0 8px 16px rgba(93, 38, 132, 0.2)", // Softer, more modern shadow
          }}
        >
          
<Formik
      initialValues={initialValues}
      validationSchema={validationSchema[currentStep]}
      onSubmit={(e)=>{
        currentStep === 8 &&  handleSubmit(e)
      }
      }
    >
      {(props) => (
        <Form>
          {renderStep(props)}
          <div className="mt-4">
            {currentStep > 0 && (
              <button type="button" onClick={handlePrev} className="bg-[#fbb807] hover:bg-[#fbc907] text-white font-bold py-2 px-4 rounded mr-2">
                Previous
              </button>
            )}
            {currentStep < 8 && (
              <button type="button" onClick={() => handleNext(props.values)} 
              className=" bg-gradient-to-r from-[#60088C] to-[#A11E90] hover:bg-[#5d2684]  text-white font-bold py-2 px-8 rounded"
              // className="min-w-fit flex-1 md:flex-none md:min-w-[180px] flex-none w-[180px] capitalize h-[50px] bg-gradient-to-r from-[#60088C] to-[#A11E90] disabled:opacity-50 rounded"
              >
                {/* <span className="text-base font-medium text-white">
                  <p className="text-off-white font-normal">Next</p>
                  </span> */}
                Next
              </button>
            ) } { currentStep === 8 &&(
              <button type="submit" 
              className="bg-[#6e3a91] hover:bg-[#5d2684] text-white font-bold py-2 px-4 rounded"
              
              >
                Submit
              </button>
            )}
          </div>
        </Form>
      )}
    </Formik>
    </div>
    </div>
    </div>
  );
};

// ... (Individual step components: PersonalFinancialInfo, InvestmentObjectives, etc.)


const PersonalFinancialInfo = ({ values, handleChange,setFieldValue,  handleBlur, errors, touched }: any) => (
    <div className='grid md:grid-cols-3 gap-4'>
      <h3 className="text-xl col-span-3 font-semibold text-gray-700 mb-4">Personal and Financial Information</h3> {/* Subtitle */}
  
      <div className="mb-4"> {/* Form group */}
        <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Evaluator Name:</label> {/* Label */}
        <Field type="text" name="name" onChange={handleChange} onBlur={handleBlur} value={values.wealthMgr_Signature} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500" /> {/* Input field */}
        {touched.wealthMgr_Signature && errors.wealthMgr_Signature && <div className="text-red-500 text-sm mt-1">{errors.wealthMgr_Signature}</div>} {/* Error message */}
      </div>
      <div className="mb-4"> {/* Form group */}
        <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Name:</label> {/* Label */}
        <Field type="text" name="name" onChange={handleChange} onBlur={handleBlur} value={values.name} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500" /> {/* Input field */}
        {touched.name && errors.name && <div className="text-red-500 text-sm mt-1">{errors.name}</div>} {/* Error message */}
      </div>
      <div className="mb-4"> {/* Form group */}
        <label htmlFor="email" className="block text-gray-700 font-medium mb-2">Email:</label> {/* Label */}
        <Field type="email" name="email" onChange={handleChange} onBlur={handleBlur} value={values.email} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500" /> {/* Input field */}
        {touched.email && errors.email && <div className="text-red-500 text-sm mt-1">{errors.email}</div>} {/* Error message */}
      </div>
  
      {/* ... other fields similarly styled */}
          <div className="mb-4">
            <label htmlFor="dob" className="block text-gray-700 font-medium mb-2">Date of Birth:</label>
            <Field type="date" name="dob" onChange={handleChange} onBlur={handleBlur} value={values.dob} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
            {touched.dob && errors.dob && <div className="text-red-500 text-sm mt-1">{errors.dob}</div>}
          </div>
  
          <div className="mb-4">
            <label htmlFor="occupation" className="block text-gray-700 font-medium mb-2">Occupation:</label>
            <Field type="text" name="occupation" onChange={handleChange} onBlur={handleBlur} value={values.occupation} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
            {touched.occupation && errors.occupation && <div className="text-red-500 text-sm mt-1">{errors.occupation}</div>}
          </div>
  
          <div className="mb-4">
            <label htmlFor="maritalStatus" className="block text-gray-700 font-medium mb-2">Marital Status:</label>
            <Field as="select" name="maritalStatus" onChange={handleChange} onBlur={handleBlur} value={values.maritalStatus} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="">Select</option>
              <option value="Single">Single</option>
              <option value="Married">Married</option>
              <option value="Divorced">Divorced</option>
              <option value="Widowed">Widowed</option>
            </Field>
            {touched.maritalStatus && errors.maritalStatus && <div className="text-red-500 text-sm mt-1">{errors.maritalStatus}</div>}
          </div>
  
          <div className="mb-4">
            <label htmlFor="dependents" className="block text-gray-700 font-medium mb-2">Dependents:</label>
            <Field type="number" name="dependents" onChange={handleChange} onBlur={handleBlur} value={values.dependents} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
            {touched.dependents && errors.dependents && <div className="text-red-500 text-sm mt-1">{errors.dependents}</div>}
          </div>
  
          <div className="mb-4">
            <label htmlFor="annualIncome" className="block text-gray-700 font-medium mb-2">Annual Income:</label>
            <Field type="number" name="annualIncome" onChange={handleChange} onBlur={handleBlur} value={values.annualIncome} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
            {touched.annualIncome && errors.annualIncome && <div className="text-red-500 text-sm mt-1">{errors.annualIncome}</div>}
          </div>
  
          <div className="mb-4">
            <label htmlFor="netWorth" className="block text-gray-700 font-medium mb-2">Net Worth:</label>
            <Field type="number" name="netWorth" onChange={handleChange} onBlur={handleBlur} value={values.netWorth} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
            {touched.netWorth && errors.netWorth && <div className="text-red-500 text-sm mt-1">{errors.netWorth}</div>}
          </div>
  
          <div className="mb-4">
            <label htmlFor="wealthSource" className="block text-gray-700 font-medium mb-2">Primary Sources of Wealth:</label>
            <Field type="text" name="wealthSource" onChange={handleChange} onBlur={handleBlur} value={values.wealthSource} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
            {touched.wealthSource && errors.wealthSource && <div className="text-red-500 text-sm mt-1">{errors.wealthSource}</div>}
          </div>
  
          <div className="mb-4">
            <label htmlFor="investmentExperience" className="block text-gray-700 font-medium mb-2">Current Investment Experience (years):</label>
            <Field type="number" name="investmentExperience" onChange={handleChange} onBlur={handleBlur} value={values.investmentExperience} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
            {touched.investmentExperience && errors.investmentExperience && <div className="text-red-500 text-sm mt-1">{errors.investmentExperience}</div>}
          </div>

        <div className="mb-4"> {/* Form group */}
        <label htmlFor="file" className="block text-gray-700 font-medium mb-2">Client Signature:</label> {/* Label */}
        <input
         type="file" name="file" onChange={
         e=>{
           const file = e?.target?.files?.[0];
           console.log({file}) 

          if (file) {
            const reader = new FileReader();
      
            reader.onload = (base64) => {
              const base64String= base64?.target?.result as string ;
              setFieldValue("clientSignature", base64String?.replace("data:image/png;base64,", ""))

              console.log({base64:base64.target?.result})
              // base64Output.value = e?.target?.result;  // Assign the base64 string
            };
      
             reader.onerror = (error) => {
                console.log( "Error reading file: " + JSON.stringify(error))
             };
      
      
            reader.readAsDataURL(file); // This reads the file as a data URL, which includes the base64 encoding
          } else {
            console.log("No file selected");
            // base64Output.value = ""; // Clear if no file selected
          }
        
          // handleChange(e)
           }} onBlur={handleBlur} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500" /> {/* Input field */}
        {touched.file && errors.file && <div className="text-red-500 text-sm mt-1">{errors.email}</div>} {/* Error message */}
      </div>
  
    </div>
  );
  
  const InvestmentObjectives = ({ values, handleChange, handleBlur, errors, touched }: any) => (
    <div>
      <h3 className="text-xl font-semibold text-gray-700 mb-4">Investment Objectives</h3>
  
      <div className="mb-4">
        <label className="block text-gray-700 font-medium mb-2">What are your primary investment goals?</label>
        <div className="flex flex-col space-y-2"> {/* Arrange checkboxes vertically */}
          <label className="inline-flex items-center"> {/* Align checkbox and label */}
            <Field type="checkbox" name="investmentGoals" value="Capital Preservation" className="mr-2 accent-blue-500" /> {/* Add margin and color */}
            <span>Capital Preservation</span> {/* Wrap text in span for styling */}
          </label>
          <label className="inline-flex items-center">
            <Field type="checkbox" name="investmentGoals" value="Income Generation" className="mr-2 accent-blue-500" />
            <span>Income Generation</span>
          </label>
          <label className="inline-flex items-center">
            <Field type="checkbox" name="investmentGoals" value="Capital Appreciation" className="mr-2 accent-blue-500" />
            <span>Capital Appreciation</span>
          </label>
          <label className="inline-flex items-center">
            <Field type="checkbox" name="investmentGoals" value="Absolute Return" className="mr-2 accent-blue-500" />
            <span>Absolute return of </span>
            <Field type="number" name="absoluteReturn" className="border rounded py-1 px-2 w-20 inline-block mr-1 focus:outline-none focus:ring-2 focus:ring-blue-500" />
            <span>%</span>
          </label>
        </div>
      </div>
  
  
      <div className="mb-4">
        <label htmlFor="timeHorizon" className="block text-gray-700 font-medium mb-2">What is your investment time horizon?</label>
        <Field as="select" name="timeHorizon" onChange={handleChange} onBlur={handleBlur} value={values.timeHorizon} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Select</option>
          <option value="Short-term">Short-term (0-1 year)</option>
          <option value="Medium-term">Medium-term (Above 1-10 years)</option>
          <option value="Long-term">Long-term (Above 10 years)</option>
        </Field>
        {touched.timeHorizon && errors.timeHorizon && <div className="text-red-500 text-sm mt-1">{errors.timeHorizon}</div>}
      </div>
  
      <div className="mb-4">
        <label htmlFor="investmentType" className="block text-gray-700 font-medium mb-2">What is your investment type?</label>
        <Field as="select" name="investmentType" onChange={handleChange} onBlur={handleBlur} value={values.investmentType} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Select</option>
          <option value="Discretionary Mandate">Discretionary Mandate</option>
          <option value="Non-Discretionary Mandate">Non-Discretionary Mandate</option>
          <option value="Execution-Only Mandate">Execution-Only Mandate</option>
        </Field>
        {touched.investmentType && errors.investmentType && <div className="text-red-500 text-sm mt-1">{errors.investmentType}</div>}
      </div>
  
      {/* ... other fields with similar styling */}
          <div className="mb-4">
              <label htmlFor="currency" className="block text-gray-700 font-medium mb-2">What currencies will your investments be based on?</label>
              <div className="flex flex-col space-y-2">
                  <label className="inline-flex items-center">
                      <Field type="checkbox" name="currency" value="Nigerian Naira" className="mr-2 accent-blue-500" />
                      <span>Nigerian Naira</span>
                  </label>
                  <label className="inline-flex items-center">
                      <Field type="checkbox" name="currency" value="United States Dollar" className="mr-2 accent-blue-500" />
                      <span>United States Dollar</span>
                  </label>
                  <label className="inline-flex items-center">
                      <Field type="checkbox" name="currency" value="Great Britain Pounds" className="mr-2 accent-blue-500" />
                      <span>Great Britain Pounds</span>
                  </label>
                  <label className="inline-flex items-center">
                      <Field type="checkbox" name="currency" value="Other" className="mr-2 accent-blue-500" />
                      <span>Other:</span>
                      <Field type="text" name="otherCurrency" className="border rounded py-1 px-2 w-48 inline-block ml-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                  </label>
              </div>
          </div>
  
          <div className="mb-4">
              <label htmlFor="liquidityNeeds" className="block text-gray-700 font-medium mb-2">Do you have any specific liquidity needs?</label>
              <div className="flex flex-col">
                  <label className="inline-flex items-center">
                      <Field type="radio" name="hasLiquidityNeeds" value="yes" className="mr-2 accent-blue-500" />
                      <span>Yes:</span>
                      <Field type="text" name="liquidityNeeds" className="border rounded py-1 px-2 w-full ml-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                  </label>
                  <label className="inline-flex items-center mt-2">
                      <Field type="radio" name="hasLiquidityNeeds" value="no" className="mr-2 accent-blue-500" />
                      <span>No</span>
                  </label>
              </div>
          </div>
  
          <div className="mb-4">
              <label htmlFor="liquidAssetPortion" className="block text-gray-700 font-medium mb-2">Desired portion of investments in liquid assets:</label>
              <Field as="select" name="liquidAssetPortion" onChange={handleChange} onBlur={handleBlur} value={values.liquidAssetPortion} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
                  <option value="">Select</option>
                  <option value="0-10%">0-10%</option>
                  <option value="11-25%">11-25%</option>
                  <option value="26-50%">26-50%</option>
                  <option value="51-75%">51-75%</option>
                  <option value="76-100%">76-100%</option>
              </Field>
              {touched.liquidAssetPortion && errors.liquidAssetPortion && <div className="text-red-500 text-sm mt-1">{errors.liquidAssetPortion}</div>}
          </div>
  
          <div className="mb-4">
              <label htmlFor="legalConsiderations" className="block text-gray-700 font-medium mb-2">Are there any legal or regulatory considerations?</label>
              <div className="flex flex-col">
                  <label className="inline-flex items-center">
                      <Field type="radio" name="hasLegalConsiderations" value="yes" className="mr-2 accent-blue-500" />
                      <span>Yes:</span>
                      <Field type="text" name="legalConsiderations" className="border rounded py-1 px-2 w-full ml-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
                  </label>
                  <label className="inline-flex items-center mt-2">
                      <Field type="radio" name="hasLegalConsiderations" value="no" className="mr-2 accent-blue-500" />
                      <span>No</span>
                  </label>
              </div>
          </div>
    </div>
  );


// ... other step components similarly


const RiskToleranceReturn = ({ values, handleChange, handleBlur, errors, touched }: any) => (
    <div>
      <h3 className="text-xl font-semibold text-gray-700 mb-4">Risk Tolerance and Return Expectations</h3>
  
      <div className="mb-4">
        <label htmlFor="riskTolerance" className="block text-gray-700 font-medium mb-2">How would you describe your risk tolerance?</label>
        <Field as="select" name="riskTolerance" onChange={handleChange} onBlur={handleBlur} value={values.riskTolerance} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Select</option>
          <option value="Conservative">Conservative: Preservation of capital is most important.</option> {/* Added descriptions */}
          <option value="Moderate">Moderate: Willing to accept some risk for moderate returns.</option>
          <option value="Aggressive">Aggressive: Willing to accept significant risk for higher returns.</option>
        </Field>
        {touched.riskTolerance && errors.riskTolerance && <div className="text-red-500 text-sm mt-1">{errors.riskTolerance}</div>}
      </div>
  
      <div className="mb-4">
        <label htmlFor="returnExpectations" className="block text-gray-700 font-medium mb-2">What are your return expectations?</label>
        <Field as="select" name="returnExpectations" onChange={handleChange} onBlur={handleBlur} value={values.returnExpectations} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Select</option>
          <option value="Below 5%">Below 5% annually (Lower risk, lower return)</option> {/* Added descriptions */}
          <option value="5-8%">5-8% annually (Moderate risk, moderate return)</option>
          <option value="Above 8%">Above 8% annually (Higher risk, higher return)</option>
        </Field>
        {touched.returnExpectations && errors.returnExpectations && <div className="text-red-500 text-sm mt-1">{errors.returnExpectations}</div>}
      </div>
  
      <div className="mb-4">
        <label htmlFor="portfolioDeclineReaction" className="block text-gray-700 font-medium mb-2">How would you react to a 20% decline in your portfolio value?</label>
        <Field as="select" name="portfolioDeclineReaction" onChange={handleChange} onBlur={handleBlur} value={values.portfolioDeclineReaction} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Select</option>
          <option value="Very Concerned">Very Concerned: I would likely want to reduce risk.</option> {/* Added descriptions */}
          <option value="Somewhat Concerned">Somewhat Concerned: I might make minor adjustments.</option>
          <option value="Unconcerned">Unconcerned: I understand the long-term nature of investing.</option>
        </Field>
        {touched.portfolioDeclineReaction && errors.portfolioDeclineReaction && <div className="text-red-500 text-sm mt-1">{errors.portfolioDeclineReaction}</div>}
      </div>
  
    </div>
  );


  const AssetAllocation = ({ values, handleChange, handleBlur, errors, touched }: any) => (
    <div>
      <h3 className="text-xl font-semibold text-gray-700 mb-4">Asset Allocation Preferences</h3>
  
      <p className="mb-4 text-gray-600">What is your preferred allocation to the following asset classes? (Enter percentage totals to 100%)</p> {/* Instructions */}
  
      <div className="mb-4">
        <label htmlFor="moneyMarket" className="block text-gray-700 font-medium mb-2">Money Market Instruments:</label>
        <div className="flex items-center"> {/* Flexbox for label and input alignment */}
          <Field type="number" name="moneyMarket" onChange={handleChange} onBlur={handleBlur} value={values.moneyMarket} className="border rounded w-24 py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500 mr-2" /> {/* Specific width */}
          <span>%</span> {/* Percentage symbol */}
        </div>
        {touched.moneyMarket && errors.moneyMarket && <div className="text-red-500 text-sm mt-1">{errors.moneyMarket}</div>}
      </div>
  
      <div className="mb-4">
        <label htmlFor="bonds" className="block text-gray-700 font-medium mb-2">Bonds:</label>
        <div className="flex items-center">
          <Field type="number" name="bonds" onChange={handleChange} onBlur={handleBlur} value={values.bonds} className="border rounded w-24 py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500 mr-2" />
          <span>%</span>
        </div>
        {touched.bonds && errors.bonds && <div className="text-red-500 text-sm mt-1">{errors.bonds}</div>}
      </div>
  
      <div className="mb-4">
        <label htmlFor="equities" className="block text-gray-700 font-medium mb-2">Equities:</label>
        <div className="flex items-center">
          <Field type="number" name="equities" onChange={handleChange} onBlur={handleBlur} value={values.equities} className="border rounded w-24 py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500 mr-2" />
          <span>%</span>
        </div>
        {touched.equities && errors.equities && <div className="text-red-500 text-sm mt-1">{errors.equities}</div>}
      </div>
  
      <div className="mb-4">
        <label htmlFor="alternatives" className="block text-gray-700 font-medium mb-2">Alternative Investments:</label>
        <div className="flex items-center">
          <Field type="number" name="alternatives" onChange={handleChange} onBlur={handleBlur} value={values.alternatives} className="border rounded w-24 py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500 mr-2" />
          <span>%</span>
        </div>
        {touched.alternatives && errors.alternatives && <div className="text-red-500 text-sm mt-1">{errors.alternatives}</div>}
      </div>
  
      {/* ... other fields (Asset Avoidance, Market Opportunity, SRI) */}
      <div className="mb-4">
          <label htmlFor="assetAvoidance" className="block text-gray-700 font-medium mb-2">Do you have any specific asset classes or sectors you prefer to avoid?</label>
          <div className="flex flex-col">
              <label className="inline-flex items-center">
                  <Field type="radio" name="hasAssetAvoidance" value="yes" className="mr-2 accent-blue-500" />
                  <span>Yes:</span>
                  <Field type="text" name="assetAvoidance" className="border rounded py-1 px-2 w-full ml-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
              </label>
              <label className="inline-flex items-center mt-2">
                  <Field type="radio" name="hasAssetAvoidance" value="no" className="mr-2 accent-blue-500" />
                  <span>No</span>
              </label>
          </div>
      </div>
  
      <div className="mb-4">
          <label htmlFor="marketOpportunity" className="block text-gray-700 font-medium mb-2">If there are market opportunities to make</label>
          <Field as="select" name="marketOpportunity" onChange={handleChange} onBlur={handleBlur} value={values.marketOpportunity} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="">Select</option>
              <option value="0-10%">0-10%</option>
              <option value="11-25%">11-25%</option>
              <option value="26-50%">26-50%</option>
          </Field>
          {touched.marketOpportunity && errors.marketOpportunity && <div className="text-red-500 text-sm mt-1">{errors.marketOpportunity}</div>}
      </div>
  
      <div className="mb-4">
          <label htmlFor="sri" className="block text-gray-700 font-medium mb-2">Are you interested in Sustainable or Socially Responsible Investing (SRI/ESG)?</label>
          <Field as="select" name="sri" onChange={handleChange} onBlur={handleBlur} value={values.sri} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="">Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
              <option value="Unsure">Unsure</option>
          </Field>
          {touched.sri && errors.sri && <div className="text-red-500 text-sm mt-1">{errors.sri}</div>}
      </div>
  
  
  
    </div>
  );


  const InvestmentCriteria = ({ values, handleChange, handleBlur, errors, touched }: any) => {
    const rankingOptions = [
      "Performance History",
      "Risk Level",
      "Management Quality",
      "Fees and Costs",
      "Ethical Considerations",
      "Other"
    ];
  
    return (
      <div>
        <h3 className="text-xl font-semibold text-gray-700 mb-4">Investment Selection Criteria</h3>
  
        <p className="mb-4 text-gray-600">What factors are most important to you when selecting investments? (Rank in order of importance)</p>
  
        {rankingOptions.map((option, index) => (
          <div key={option} className="mb-4">
            <label className="block text-gray-700 font-medium mb-2">{option}:</label>
            <div className="flex items-center">
              <Field as="select" name={`${option.toLowerCase().replace(/ /g, '_')}Rank`}  onChange={handleChange} onBlur={handleBlur} value={values[`${option.toLowerCase().replace(/ /g, '_')}Rank`]} className="border rounded w-32 py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500 mr-2">
                <option value="">Select Rank</option>
                {[1, 2, 3, 4, 5, 6].map(rank => (
                  <option key={rank} value={rank}>{rank}</option>
                ))}
              </Field>
              {/* Conditionally render the "Other" input field */}
              {option === "Other" && (
                <Field type="text" name="otherFactors" onChange={handleChange} onBlur={handleBlur} value={values.otherFactors} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Please specify" />
              )}
            </div>
            {touched[`${option.toLowerCase().replace(/ /g, '_')}Rank`] && errors[`${option.toLowerCase().replace(/ /g, '_')}Rank`] && <div className="text-red-500 text-sm mt-1">{errors[`${option.toLowerCase().replace(/ /g, '_')}Rank`]}</div>}
          </div>
        ))}
  
      </div>
    );
  };


  const PortfolioMonitoring = ({ values, handleChange, handleBlur, errors, touched }: any) => (
    <div>
      <h3 className="text-xl font-semibold text-gray-700 mb-4">Portfolio Monitoring and Rebalancing</h3>
  
      <div className="mb-4">
        <label htmlFor="reportFrequency" className="block text-gray-700 font-medium mb-2">How frequently would you like to receive investment management reports?</label>
        <Field as="select" name="reportFrequency" onChange={handleChange} onBlur={handleBlur} value={values.reportFrequency} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Select</option>
          <option value="Monthly">Monthly</option>
          <option value="Quarterly">Quarterly</option>
          <option value="Semi-annually">Semi-annually</option>
          <option value="Annually">Annually</option>
        </Field>
        {touched.reportFrequency && errors.reportFrequency && <div className="text-red-500 text-sm mt-1">{errors.reportFrequency}</div>}
      </div>
  
      <div className="mb-4">
        <label htmlFor="reviewFrequency" className="block text-gray-700 font-medium mb-2">How often would you like to have formal reviews of your portfolio?</label>
        <Field as="select" name="reviewFrequency" onChange={handleChange} onBlur={handleBlur} value={values.reviewFrequency} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Select</option>
          <option value="Monthly">Monthly</option>
          <option value="Quarterly">Quarterly</option>
          <option value="Semi-annually">Semi-annually</option>
          <option value="Annually">Annually</option>
        </Field>
        {touched.reviewFrequency && errors.reviewFrequency && <div className="text-red-500 text-sm mt-1">{errors.reviewFrequency}</div>}
      </div>
  
      <div className="mb-4">
        <label htmlFor="rebalancing" className="block text-gray-700 font-medium mb-2">Do you have any preferences for portfolio rebalancing?</label>
        <div className="flex flex-col">
          <label className="inline-flex items-center">
            <Field type="radio" name="rebalancingPreference" value="automatic" className="mr-2 accent-blue-500" onChange={handleChange} onBlur={handleBlur}  />
            <span>Automatic rebalancing when allocations deviate by more than</span>
            <Field type="number" name="rebalancingThreshold" className="border rounded py-1 px-2 w-20 inline-block ml-2 mr-1 focus:outline-none focus:ring-2 focus:ring-blue-500" disabled={values.rebalancingPreference !== "automatic"}  onChange={handleChange} onBlur={handleBlur} value={values.rebalancingThreshold}/>
            <span>%</span>
          </label>
          <label className="inline-flex items-center mt-2">
            <Field type="radio" name="rebalancingPreference" value="review" className="mr-2 accent-blue-500" onChange={handleChange} onBlur={handleBlur} />
            <span>Rebalancing only during formal reviews</span>
          </label>
          <label className="inline-flex items-center mt-2">
            <Field type="radio" name="rebalancingPreference" value="other" className="mr-2 accent-blue-500" onChange={handleChange} onBlur={handleBlur} />
            <span>Other:</span>
            <Field type="text" name="rebalancingOther" className="border rounded py-1 px-2 w-full ml-2 focus:outline-none focus:ring-2 focus:ring-blue-500" disabled={values.rebalancingPreference !== "other"}  onChange={handleChange} onBlur={handleBlur} value={values.rebalancingOther} />
          </label>
        </div>
      </div>
  
    </div>
  );


  const EthicalConsiderations = ({ values, handleChange, handleBlur, errors, touched }: any) => (
    <div>
      <h3 className="text-xl font-semibold text-gray-700 mb-4">Ethical and Social Considerations</h3>
  
      <div className="mb-4">
        <label htmlFor="ethicalAvoidance" className="block text-gray-700 font-medium mb-2">Are there any industries or companies you prefer to avoid for ethical reasons?</label>
        <div className="flex flex-col">
          <label className="inline-flex items-center">
            <Field type="radio" name="hasEthicalAvoidance" value="yes" className="mr-2 accent-blue-500" onChange={handleChange} onBlur={handleBlur} />
            <span>Yes:</span>
            <Field type="text" name="ethicalAvoidance" className="border rounded py-1 px-2 w-full ml-2 focus:outline-none focus:ring-2 focus:ring-blue-500" disabled={values.hasEthicalAvoidance !== "yes"} onChange={handleChange} onBlur={handleBlur} value={values.ethicalAvoidance} />
          </label>
          <label className="inline-flex items-center mt-2">
            <Field type="radio" name="hasEthicalAvoidance" value="no" className="mr-2 accent-blue-500" onChange={handleChange} onBlur={handleBlur} />
            <span>No</span>
          </label>
        </div>
      </div>
    </div>
  );


  const FeesTransparency = ({ values, handleChange, handleBlur, errors, touched }: any) => (
    <div>
      <h3 className="text-xl font-semibold text-gray-700 mb-4">Fees and Transparency</h3>
  
      <div className="mb-4">
        <label htmlFor="feeStructure" className="block text-gray-700 font-medium mb-2">How would you prefer fees to be structured?</label>
        <Field as="select" name="feeStructure" onChange={handleChange} onBlur={handleBlur} value={values.feeStructure} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Select</option>
          <option value="Flat fee">Flat fee</option>
          <option value="Percentage of assets under management">Percentage of assets under management</option>
          <option value="Performance-based fee">Performance-based fee</option>
          <option value="Other">Other (Please specify)</option>
        </Field>
        {touched.feeStructure && errors.feeStructure && <div className="text-red-500 text-sm mt-1">{errors.feeStructure}</div>}
      </div>
  
      <div className="mb-4">
        <label htmlFor="feeCommunication" className="block text-gray-700 font-medium mb-2">What is your preference for how fees are communicated?</label>
        <Field as="select" name="feeCommunication" onChange={handleChange} onBlur={handleBlur} value={values.feeCommunication} className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="">Select</option>
          <option value="Included in regular reports">Included in regular reports</option>
          <option value="Separate detailed breakdowns">Separate detailed breakdowns</option>
          <option value="Other">Other (Please specify)</option>
        </Field>
        {touched.feeCommunication && errors.feeCommunication && <div className="text-red-500 text-sm mt-1">{errors.feeCommunication}</div>}
      </div>
  
    </div>
  );

  const AdditionalInformation = ({ values, handleChange, handleBlur, errors, touched }: any) => (
    <div>
      <h3 className="text-xl font-semibold text-gray-700 mb-4">Additional Information</h3>
  
      <div className="mb-4">
        <label htmlFor="additionalInfo" className="block text-gray-700 font-medium mb-2">Is there anything else we should know to better understand your financial situation and goals?</label>
        <Field as="textarea" name="additionalInfo" onChange={handleChange} onBlur={handleBlur} value={values.additionalInfo} rows="4" className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
        {touched.additionalInfo && errors.additionalInfo && <div className="text-red-500 text-sm mt-1">{errors.additionalInfo}</div>}
      </div>
  
      <div className="mb-4">
        <label htmlFor="specificConcerns" className="block text-gray-700 font-medium mb-2">Do you have any specific concerns or questions about your investment plan?</label>
        <Field as="textarea" name="specificConcerns" onChange={handleChange} onBlur={handleBlur} value={values.specificConcerns} rows="4" className="border rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500" />
        {touched.specificConcerns && errors.specificConcerns && <div className="text-red-500 text-sm mt-1">{errors.specificConcerns}</div>}
      </div>
  
    </div>
  );
    export default MultiStepForm